import { render, staticRenderFns } from "./DialogConfirmImportAccount.vue?vue&type=template&id=987ea0e4&"
import script from "./DialogConfirmImportAccount.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmImportAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports